/**
 * This file originally exported to AJS.Confluence.Editor._Profiles global var in Confluence.
 */

function createProfileForCommentEditor() {
	const plugins = [
		'searchreplace',
		'confluenceimagedialog',
		'autocompletemacro',
		'confluencemacrobrowser',
		'confluenceleavecomment', // TODO: will ask for confirmation before leaving a dirty editor - may not be needed, already taken care of by CommentsSection._warnCommentLost()
		'confluencewatch',
		'autoresize',
		'Adg3Editor',
	];

	return {
		plugins,
	};
}

function createProfileForPageEditor(options) {
	const plugins = [
		'searchreplace',
		'confluencedrafts',
		// save bar UI elements will be inserted according to this ordering
		'confluenceimagedialog',
		'autocompletemacro',
		'confluencemacrobrowser',
		'flextofullsize',
		'referrer',
		'Adg3Editor',
		'fabric_migration',
	];

	if (options && options.versionComment) {
		plugins.push('confluenceversioncomment');
	}

	if (options && options.notifyWatchers) {
		plugins.push('confluencenotifywatchers');
	}

	return {
		plugins,
	};
}

/**
 * TODO: Templates are not in SPA yet.
 *
 * @returns {{plugins: array}}
 */
function createProfileForTemplateEditor() {
	const plugins = [
		'searchreplace',
		// save bar UI elements will be inserted according to this ordering
		'confluenceimagedialog',
		'autocompletemacro',
		'confluencemacrobrowser',
		'confluenceleavetemplate', // confirmation on dirty editor
		'flextofullsize',
		'confluencetemplateeditor',
		'Adg3Editor',
	];

	return {
		plugins,
	};
}

export default {
	/**
	 * Editor profile for comments
	 * @param {object} options initialisation options
	 * @param {object} options.watch includes the watch plugin
	 */

	createProfileForCommentEditor,

	/**
	 * Editor profile for page/blogpost edition
	 */

	createProfileForPageEditor,

	/**
	 * Editor profile for template edition
	 */

	createProfileForTemplateEditor,
};
